var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["category-primary-content-slot.j2"] = require( "category-primary-content-slot.j2" );
dependencies["category-breadcrumbs.j2"] = require( "category-breadcrumbs.j2" );
dependencies["category-header.j2"] = require( "category-header.j2" );
dependencies["category-main-view-columns.j2"] = require( "category-main-view-columns.j2" );
dependencies["category-landing.j2"] = require( "category-landing.j2" );
dependencies["category-badges.j2"] = require( "category-badges.j2" );
dependencies["category-browse.j2"] = require( "category-browse.j2" );
dependencies["category-paging.j2"] = require( "category-paging.j2" );
dependencies["brand/brand-footer-copy.j2"] = require( "brand/brand-footer-copy.j2" );
dependencies["category-seo-copy.j2"] = require( "category-seo-copy.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-layout.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSearch")?"":runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug")));
frame.set("navType", t_1, true);
if(frame.topLevel) {
context.setVariable("navType", t_1);
}
if(frame.topLevel) {
context.addExport("navType", t_1);
}
var t_2;
t_2 = env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"templateOptions")),"typeCode"),"DEFAULT");
frame.set("pageType", t_2, true);
if(frame.topLevel) {
context.setVariable("pageType", t_2);
}
if(frame.topLevel) {
context.addExport("pageType", t_2);
}
output += "<div class=\"c-category-content-wrapper dom-category-layout\" data-qa-category-results=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount"), env.opts.autoescape);
output += "\">\n\n    <div class=\"o-row\">\n\n        <div class=\"o-row o-column o-extra-small--12\">\n\n            ";
env.getTemplate("category-primary-content-slot.j2", false, "category/templates/category-layout.j2", null, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
t_3.render(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
output += t_4
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSearch") && !runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "pageType"),["GATEWAY_NN","OLAPIC"])) {
output += "\n                ";
env.getTemplate("category-breadcrumbs.j2", false, "category/templates/category-layout.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n            ";
})});
}
env.getTemplate("category-header.j2", false, "category/templates/category-layout.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n\n        </div>\n\n    </div>\n\n    <div class=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context") == "brands"?"s-brands-page":""), env.opts.autoescape);
output += " o-row c-category--main-view-container\">";
if(runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "pageType"),["GATEWAY_NN","OLAPIC","NO_NAV"]) || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context") != "category" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") == 0)) {
output += "\n            <div class=\"o-column o-large--12\">";
;
}
else {
output += "\n            ";
env.getTemplate("category-main-view-columns.j2", false, "category/templates/category-layout.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
})});
}
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"landingPage")) {
output += "\n            ";
env.getTemplate("category-landing.j2", false, "category/templates/category-layout.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
output += "\n        ";
})});
}
else {
output += "\n            ";
env.getTemplate("category-badges.j2", false, "category/templates/category-layout.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
output += t_24
output += "\n            ";
env.getTemplate("category-browse.j2", false, "category/templates/category-layout.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
output += "\n        ";
})})})});
}
output += "\n\n        ";
output += "\n        </div>\n\n    </div>";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") > 0 && !runtime.inOperator(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"templateOptions")),"typeCode"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"landingTypeCodes"))) {
output += "\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-large--offset-10 o-large--2 o-pagination__category-bottom dom-paging-bottom\" data-qa-paging-bottom>\n                ";
var t_31;
t_31 = "BOTTOM";
frame.set("categoryPagingLocation", t_31, true);
if(frame.topLevel) {
context.setVariable("categoryPagingLocation", t_31);
}
if(frame.topLevel) {
context.addExport("categoryPagingLocation", t_31);
}
output += "\n                ";
env.getTemplate("category-paging.j2", false, "category/templates/category-layout.j2", null, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
t_32.render(context.getVariables(), frame, function(t_35,t_33) {
if(t_35) { cb(t_35); return; }
output += t_33
output += "\n            </div>\n\n        </div>\n\n        ";
env.getTemplate("brand/brand-footer-copy.j2", false, "category/templates/category-layout.j2", null, function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
t_36.render(context.getVariables(), frame, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
output += t_37
output += "\n\n    ";
})})})});
}
if(runtime.contextOrFrameLookup(context, frame, "navType") != "BRAND") {
output += "\n        ";
env.getTemplate("category-seo-copy.j2", false, "category/templates/category-layout.j2", null, function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
t_40.render(context.getVariables(), frame, function(t_43,t_41) {
if(t_43) { cb(t_43); return; }
output += t_41
output += "\n    ";
})});
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-layout.j2"] , dependencies)